import { appLangLinkUntyped } from '@bcf2-v1-ui-routes/app-lang-link';
import { msg } from '@lit/localize';
import type { FooterLinksConfig } from '../types';

export const sportsbookFooterLinks = (): FooterLinksConfig => [
  {
    title: msg('General info'),
    links: [
      {
        label: msg('Terms and conditions'),
        url: appLangLinkUntyped('/sp/terms-and-conditions/')
      },
      {
        label: msg('Bonus terms'),
        url: appLangLinkUntyped('/sp/bonus-terms/')
      },
      {
        label: msg('General betting rules'),
        url: appLangLinkUntyped('/sp/betting-rules/')
      },
      {
        label: msg('Special rules for sports'),
        url: appLangLinkUntyped('/sp/special-rules-for-sports/')
      },
      {
        label: msg('Responsible gaming'),
        url: appLangLinkUntyped('/sp/responsible-gaming/')
      },
      {
        label: msg('Refund policy'),
        url: appLangLinkUntyped('/sp/refund-policy/')
      },
      {
        label: msg('Affiliate program'),
        url: 'https://www.click2.partners/'
      },
      {
        label: msg('Sitemap'),
        url: appLangLinkUntyped('/sp/sitemap/')
      }
    ]
  },
  {
    title: msg('Main pages'),
    links: [
      {
        label: msg('Live Betting'),
        url: appLangLinkUntyped('/live/')
      },
      {
        label: msg('Promotions'),
        url: appLangLinkUntyped('/promotions/')
      },
      {
        label: msg('Support'),
        url: appLangLinkUntyped('/support/')
      }
    ]
  },
  {
    title: msg('Sports betting'),
    links: [
      {
        label: msg('Basketball Betting'),
        url: appLangLinkUntyped('/basketball-2/')
      },
      {
        label: msg('Tennis Betting'),
        url: appLangLinkUntyped('/tennis-5/')
      },
      {
        label: msg('Ice Hockey Betting'),
        url: appLangLinkUntyped('/ice-hockey-4/')
      },
      {
        label: msg('Handball Betting'),
        url: appLangLinkUntyped('/handball-6/')
      },
      {
        label: msg('Darts Betting'),
        url: appLangLinkUntyped('/darts-22/')
      },
      {
        label: msg('Volleyball Betting'),
        url: appLangLinkUntyped('/volleyball-23/')
      },
      {
        label: msg('Table Tennis Betting'),
        url: appLangLinkUntyped('/table-tennis-20/')
      },
      {
        label: msg('Baseball Betting'),
        url: appLangLinkUntyped('/baseball-3/')
      },
      {
        label: msg('American Football Betting'),
        url: appLangLinkUntyped('/american-football-16/')
      },
      {
        label: msg('Boxing Betting'),
        url: appLangLinkUntyped('/boxing-10/')
      }
    ]
  },
  {
    title: msg('Football'),
    links: [
      {
        label: msg('Football Betting'),
        url: appLangLinkUntyped('/soccer-1/')
      },
      {
        label: msg('Champions League Betting'),
        url: appLangLinkUntyped('/soccer/international/uefa-champions-league-2470546796305330203/')
      },
      {
        label: msg('Europa League Betting'),
        url: appLangLinkUntyped('/soccer/international/uefa-europa-league-2480852763123261476/')
      },
      {
        label: msg('Premier League Betting'),
        url: appLangLinkUntyped('/soccer/england/premier-league-1669818860469096448/')
      },
      {
        label: msg('La Liga Betting'),
        url: appLangLinkUntyped('/soccer/spain/laliga-1669819032615915520/')
      },
      {
        label: msg('Serie A Betting'),
        url: appLangLinkUntyped('/soccer/italy/serie-a-1669819042829045760/')
      },
      {
        label: msg('Bundesliga Betting'),
        url: appLangLinkUntyped('/soccer/germany/bundesliga-1669818934959935488/')
      },
      {
        label: msg('Ligue 1 Betting'),
        url: appLangLinkUntyped('/soccer/france/ligue-1-1669818844560101376/')
      },
      {
        label: msg('Ekstraklasa Betting'),
        url: appLangLinkUntyped('/soccer/poland/ekstraklasa-1669818868635406336/')
      },
      {
        label: msg('MLS Betting'),
        url: appLangLinkUntyped('/soccer/usa/mls-1669819235519565824/')
      }
    ]
  },
  {
    title: msg('E-sports'),
    links: [
      {
        label: msg('Counter Strike Betting'),
        url: appLangLinkUntyped('/counter-strike-109/')
      },
      {
        label: msg('Valorant Betting'),
        url: appLangLinkUntyped('/valorant-194/')
      },
      {
        label: msg('League of Legends Betting'),
        url: appLangLinkUntyped('/league-of-legends-110/')
      },
      {
        label: msg('FC 26 Betting'),
        url: appLangLinkUntyped('/fc-26-137/')
      },
      {
        label: msg('Rocket League Betting'),
        url: appLangLinkUntyped('/rocket-league-128/')
      },
      {
        label: msg('NBA 2K26 Betting'),
        url: appLangLinkUntyped('/nba-2k26-153/')
      },
      {
        label: msg('Dota 2 Betting'),
        url: appLangLinkUntyped('/dota-2-111/')
      }
    ]
  }
];
